const trimFraction = (value: string) =>
  value.includes('.') ? value.replace(/0+$/, '').replace(/\.$/, '') : value

/**
 * Leaderboard stat format from the 2.0 design: 356, 12.4K, 986.4K, 1.24M.
 * Thousands keep one decimal, millions and billions two.
 */
export function formatLeaderboardNumber(value?: number | null): string {
  const n = Number.isFinite(value)
    ? Math.max(0, Math.trunc(value as number))
    : 0

  if (n < 1000) {
    return String(n)
  }

  const thousands = trimFraction((n / 1000).toFixed(1))
  if (Number.parseFloat(thousands) < 1000) {
    return `${thousands}K`
  }

  const millions = trimFraction((n / 1_000_000).toFixed(2))
  if (Number.parseFloat(millions) < 1000) {
    return `${millions}M`
  }

  return `${trimFraction((n / 1_000_000_000).toFixed(2))}B`
}
